import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import TableEmptyState from '../ReusableComponents/TableEmptyState';
import SweetAlert from "react-bootstrap-sweetalert";
import { FaArrowLeft, FaArrowRight, FaListAlt, FaVideo } from "react-icons/fa";
import { MdAccessTime, MdArrowLeft, MdArrowRight, MdArrowRightAlt, MdDelete, MdModeEdit, MdPlayArrow, MdScreenShare, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";

const TRUST_METRICS = [
  { key: "acoes_relatadas", labelKey: "trust_metric_reported_actions", valueLabel: trust => parseInt(trust.acoes_relatadas || 0), points: trust => Number(trust.acoes_relatadas || 0) },
  { key: "average_face", labelKey: "trust_metric_face_recognition_average", valueLabel: trust => `${parseFloat(100 - (trust.average_face || 0)).toFixed(2)}%`, points: trust => Number(trust.average_face || 0) },
  { key: "face_validaiton_again", labelKey: "trust_metric_periodic_face_validations", valueLabel: trust => trust.face_validaiton_again || 0, points: trust => Number(trust.face_validaiton_again || 0) },
  { key: "no_face", labelKey: "trust_metric_photos_without_face", valueLabel: trust => trust.no_face || 0, points: trust => Number(trust.no_face || 0) },
  { key: "request_validation", labelKey: "trust_metric_fiscal_release_requests", valueLabel: trust => trust.request_validation || 0, points: trust => Number(trust.request_validation || 0) },
  { key: "saidas", labelKey: "trust_metric_screen_exits", valueLabel: trust => trust.saidas || 0, points: trust => Number(trust.saidas || 0) },
  { key: "tempo", labelKey: "trust_metric_screen_exit_time", valueLabel: (trust, t) => `${trust.tempo || 0}${t("unit_seconds_short")}`, points: trust => Number(trust.tempo || 0) },
  { key: "video_no_face", labelKey: "trust_metric_videos_without_face", valueLabel: trust => parseFloat(trust.video_analyse?.no_face || 0).toFixed(2), points: trust => Number(trust.video_analyse?.no_face || 0) },
  { key: "video_multiple_faces", labelKey: "trust_metric_multiple_faces_videos", valueLabel: trust => parseFloat(trust.video_analyse?.multiple_faces_detected || 0).toFixed(2), points: trust => Number(trust.video_analyse?.multiple_faces_detected || 0) },
  { key: "ip_equal", labelKey: "trust_metric_identical_ips", valueLabel: trust => trust.ip_equal || 0, points: trust => Number(trust.ip_equal || 0) },
];

const VIDEO_AI_EVENTS = [
  "AI_ASSISTANT",
  "BOOK",
  "CALCULATOR",
  "CELL_PHONE",
  "EARBUDS",
  "EMAIL",
  "EXTERNAL_WEBSITE",
  "HEADPHONES",
  "LAPTOP",
  "LONG_HAIR",
  "BROWSER_NEW_TAB",
  "LOOKING_AWAY",
  "MESSAGING",
  "MULTIPLE_FACES",
  "MULTIPLE_PEOPLE",
  "MULTIPLE_SPEAKERS",
  "NO_PERSON",
  "PAPER",
  "PERSON",
  "REFERENCE",
  "SEARCH_ENGINE",
  "SECOND_SPEAKER",
  "SPEECH",
  "START_MENU",
  "SMARTWATCH",
  "TV_MONITOR",
  "UNKNOWN",
];

const translatedKey = (t, key, fallback = key) => {
  const value = t(key);
  return value === key ? fallback : value;
};

const getVideoAIEventLabel = (t, eventType) => {
  if (eventType === "NO_FACE") return t("video_ai_event_no_person");
  return translatedKey(t, `video_ai_event_${String(eventType || "").toLowerCase()}`, eventType || "-");
};



const Relatorio = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_relatorio, setLoadingrelatorio] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [logs, setlogs] = useState([]);
  const [deixou_aplicacao, setDeixouAplicacao] = useState(0);
  const [logs_saidas, setLogsSaidas] = useState([]);
  const [logs_warning, setLogsWarning] = useState([]);

  const [acoes_relatadas, setAcoesRelatadas] = useState([]);

  const [loading_allow, setLoadingAllow] = useState(false);
  const [show_btn_allow, setShowBtnAllow] = useState(false);



  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });


  const [current_page, setCurrentPage] = useState(1);
  const [last_page, setLastPage] = useState(1);

  const [search, setSearch] = useState('');
  const { candidato_id, candidato_name, processo_id, trust, trust_points } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [relatorio_id, setrelatorioId] = useState(null);
  const [selectedTrustMetrics, setSelectedTrustMetrics] = useState({});
  const [selectedAIEvents, setSelectedAIEvents] = useState({});


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Getrelatorio = async (page, search) => {

    let response = await Request.Get(`faculdade/show_relatorio_aluno/${processo_id}/${candidato_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }

    setlogs(response.logs);
    setLogsSaidas(response.logs_saidas);
    setLogsWarning(response.logs_warning);

    setDeixouAplicacao(response.deixou_aplicacao);

    setAcoesRelatadas(response.acoes_relatadas);
    // setShowBtnAllow(response.show_btn_access);




    // setPagination({...response.pagination});

    setLoadingScreen(false);
    setLoadingrelatorio(false);


  };

  const [relatorio_select, setVideoSelect] = useState(null);

  const Deleterelatorio = async (relatorio_id) => {

    let response = await Request.Delete(`faculdade/delete_relatorio/${relatorio_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getrelatorio(current_page, search_oficial);



  };

  const AccessLiberation = async () => {

    let response = await Request.Get(`faculdade/allow_access/${processo_id}/${candidato_id}`);
    console.log(response);
    setLoadingAllow(false);

    if (response === undefined) return;
    if (response.message == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    // else if(response['status']==undefined){
    //     setLoadingZip(false);

    //     saveAs(response,'provas_processo_'+processo_name+'.zip');
    // }
    else {
      setLoadingScreen(true);

      Getrelatorio(1, search_oficial);

      // saveAs(response, 'analises_candidatos_' + processo_name + '.xlsx');


    }
  };

  useEffect(() => {
    Getrelatorio(1, search_oficial);
  }, []);

  useEffect(() => {
    const selectedMetrics = {};
    TRUST_METRICS.forEach(metric => {
      selectedMetrics[metric.key] = true;
    });
    setSelectedTrustMetrics(selectedMetrics);

    const details = trust?.video_ai_event_details || {};
    const selectedEvents = {};
    Object.keys(details).forEach(eventType => {
      selectedEvents[eventType] = details[eventType].enabled !== false;
    });
    setSelectedAIEvents(selectedEvents);
  }, [trust]);

  const getTrustMetricRows = () => {
    if (!trust) {
      return [];
    }

    return TRUST_METRICS.map(metric => ({
      ...metric,
      label: t(metric.labelKey),
      value: metric.valueLabel(trust, t),
      points: metric.points(trust),
      selected: selectedTrustMetrics[metric.key] !== false,
    }));
  };

  const getVideoAIEventRows = () => {
    const details = trust?.video_ai_event_details || {};
    return Object.keys(details).map(eventType => ({
      eventType,
      label: getVideoAIEventLabel(t, eventType),
      total: details[eventType]?.total || 0,
      points: Number(details[eventType]?.points || 0),
      selected: selectedAIEvents[eventType] !== false,
    })).sort((a, b) => b.points - a.points);
  };

  const getSelectedMetricPoints = () => getTrustMetricRows().reduce((total, item) => item.selected ? total + item.points : total, 0);

  const getSelectedAIPoints = () => getVideoAIEventRows().reduce((total, item) => item.selected ? total + item.points : total, 0);

  const getSelectedAIEventsCount = () => getVideoAIEventRows().reduce((total, item) => item.selected ? total + item.total : total, 0);

  const getRecalculatedTrustPoints = () => {
    const aiPoints = getVideoAIEventRows().length > 0 ? getSelectedAIPoints() : Number(trust?.video_ai_points || 0);
    return getSelectedMetricPoints() + aiPoints;
  };

  const toggleTrustMetric = metricKey => {
    setSelectedTrustMetrics(current => ({
      ...current,
      [metricKey]: current[metricKey] === false,
    }));
  };

  const toggleAIEvent = eventType => {
    setSelectedAIEvents(current => ({
      ...current,
      [eventType]: current[eventType] === false,
    }));
  };

  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <div className="row">

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div>
                    <p className="text-muted">{t("ui_aqui_fica_o_relatorio_do_candidato_37e99da8")}{candidato_name}"</p>

                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}
                    {<div className="d-flex mt-2" style={{
            flexBasis: '50%',
            height: 'max-content',
            justifyContent: 'flex-end'
          }}>
                            {<div onClick={() => {
              if (loading_allow == false) {
                setShowWarning(true);
              } else
              {

              }
            }} style={{ textDecoration: "none", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {loading_allow == false && <Button variant="success" className="flex align-center jcc me-2"><MdAccessTime style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>{t("action_release_reset_candidate_access")}</p></Button>}
                                {loading_allow == true && <div className="me-2" style={{ paddingLeft: 10, paddingRight: 10 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    <CircularProgress size={15} />
                                </div>
                                </div>}
                            </div>}


                        </div>}
                    <div className=" mb-4 mt-4">
                    <p className="mt-0 header-title" style={{ marginBottom: 0, fontSize: '1.1rem' }}>{t("title_system_logs")}:</p>
                    </div>

                    <div className="table-modern-card">
                        <div className="table-modern-scroll">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>{t("ui_acao_d621dc82")}</th>
                                        <th>{t("label_from")}</th>
                                        <th>{t("ui_ate_fc454800")}</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_relatorio == false && logs.map((item, id) =>

                  <tr style={{}} key={id}>
                                            <td>{item.acao}</td>
                                            <td>{item.hora_inicio}</td>
                                            <td>{item.hora_fim}</td>


                                        </tr>
                  )}

                                </tbody>
                            </table>
                            {loading_relatorio == true &&
              <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                                    <CircularProgress />
                                </div></div>

              }
                        </div>
                    </div>
                    {loading_relatorio == false && logs.length == 0 && <div className="row">
                        <div className="col-12">
                            <TableEmptyState title={t("empty_no_records_found")} icon="👤" />

                        </div>
                    </div>}

                    <div className="row">
                        <div className="col-12">
                            <p><b style={{ fontWeight: 600 }}>{t("ui_saiu_da_pagina_da_aplicacao_fda9235a")}</b> {deixou_aplicacao}</p>
                        </div>
                    </div>


                    <div className=" mb-4 mt-4">
                        <p className="header-title" style={{ color: 'black', marginBottom: 0, fontSize: '1.1rem' }}>{t("ui_acoes_reportadas_3b561a75")}</p>
                    </div>

                    <div className="table-modern-card">
                        <div className="table-modern-scroll">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>
                                    <th>{t("legacy_fiscal")}</th>

                                        <th>{t("ui_acao_d621dc82")}</th>
                                        <th>{t("ui_horario_3bd854d6")}</th>
                                        <th>{t("label_actions")}</th>



                                    </tr>
                                </thead>
                                <tbody>
                                    {acoes_relatadas.map((item, id) =>

                  <tr style={{}} key={id}>
                                            <td>{item.fiscal.name}</td>
                                            <td>{item.acao}</td>
                                            <td>{moment(item.created_at).format('DD/MM/YYYY HH:mm:ss')}</td>
                                            <td>
                                                <div className="actions-group">
                                                {item.video.length > 0 && <a
                        target="_blank" href={item.video[0].url}>

                                                <span
                          className="inline-flex align-center jcc bg-success icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                          title={t("ui_ver_video_da_camera_0a3101ee")}>

                                                    <MdVideoLibrary size={17} color="white" />
                                                </span>
                                                </a>}
                                                {item.screen.length > 0 && <a
                        target="_blank" href={item.screen[0].url}>

                                                <span
                          className="inline-flex align-center jcc bg-info icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                          title={t("ui_ver_video_da_tela_b4b78e7f")}>

                                                    <MdScreenShare size={17} color="white" />
                                                </span>
                                                </a>}
                                                {item.screen.length == 0 && item.video.length == 0 && <span>-</span>}

                                                </div>
                                                </td>

                                        </tr>
                  )}

                                </tbody>
                            </table>

                        </div>
                    </div>
                    {acoes_relatadas.length == 0 && <div className="row">
                        <div className="col-12">
                            <TableEmptyState title={t("ui_nenhuma_acao_registrada_aebf4fac")} icon="👤" />

                        </div>
                    </div>}





                    <div className=" mb-4 mt-4">
                        <p className="mt-0 header-title" style={{ marginBottom: 0, fontSize: '1.1rem' }}>{t("ui_registros_de_saida_27d28fba")}</p>
                    </div>

                    <div className="table-modern-card">
                        <div className="table-modern-scroll">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>{t("ui_acao_d621dc82")}</th>
                                        <th>{t("ui_horario_3bd854d6")}</th>
                                        <th>{t("label_actions")}</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {logs_saidas.map((item, id) =>

                  <tr style={{}} key={id}>
                                            <td>{item.acao}</td>
                                            <td>{item.hora_inicio}</td>
                                            <td>
                                                <div className="actions-group">
                                                {item.video.length > 0 && <a
                        target="_blank" href={item.video[0].url}>

                                                <span
                          className="inline-flex align-center jcc bg-success icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                          title={t("ui_ver_video_da_camera_0a3101ee")}>

                                                    <MdVideoLibrary size={17} color="white" />
                                                </span>
                                                </a>}
                                                {item.screen.length > 0 && <a
                        target="_blank" href={item.screen[0].url}>

                                                <span
                          className="inline-flex align-center jcc bg-info icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                          title={t("ui_ver_video_da_tela_b4b78e7f")}>

                                                    <MdScreenShare size={17} color="white" />
                                                </span>
                                                </a>}
                                                {item.screen.length == 0 && item.video.length == 0 && <span>-</span>}

                                                </div>
                                                </td>
                                        </tr>
                  )}

                                </tbody>
                            </table>

                        </div>
                    </div>
                    {logs_saidas.length == 0 && <div className="row">
                        <div className="col-12">
                            <TableEmptyState title={t("empty_no_records_found")} icon="👤" />

                        </div>
                    </div>}



                    <div className=" mb-4 mt-4">
                        <p className="mt-0 header-title" style={{ marginBottom: 0, fontSize: '1.1rem' }}>{t("ui_avisos_de_restricao_de_horario_duas_ou_mais_telas__902f57ad")}</p>
                    </div>

                    <div className="table-modern-card">
                        <div className="table-modern-scroll">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>{t("ui_acao_d621dc82")}</th>
                                        <th>{t("ui_horario_3bd854d6")}</th>
                                        <th>{t("label_actions")}</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {logs_warning.map((item, id) =>

                  <tr style={{}} key={id}>
                                            <td>{item.acao}</td>
                                            <td>{item.hora_inicio}</td>
                                            <td>
                                                <div className="actions-group">
                                                {item.video?.length > 0 && <a
                        target="_blank" href={item.video[0].url}>

                                                <span
                          className="inline-flex align-center jcc bg-success icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                          title={t("ui_ver_video_da_camera_0a3101ee")}>

                                                    <MdVideoLibrary size={17} color="white" />
                                                </span>
                                                </a>}
                                                {item.screen?.length > 0 && <a
                        target="_blank" href={item.screen[0].url}>

                                                <span
                          className="inline-flex align-center jcc bg-info icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                          title={t("ui_ver_video_da_tela_b4b78e7f")}>

                                                    <MdScreenShare size={17} color="white" />
                                                </span>
                                                </a>}
                                                {item.screen?.length == 0 && item.video?.length == 0 && <span>-</span>}

                                                </div>
                                                </td>
                                        </tr>
                  )}

                                </tbody>
                            </table>

                        </div>
                    </div>
                    {logs_warning.length == 0 && <div className="row">
                        <div className="col-12">
                            <TableEmptyState title={t("legacy_nenhum_aviso_encontrado")} icon="👤" />

                        </div>
                    </div>}


                    <div className=" mb-4 mt-4">
                        <p className="mt-0 header-title" style={{ marginBottom: 0, fontSize: '1.1rem' }}>{t("title_reliability")}: </p>
                    </div>

                    {trust && <div className="table-modern-card">
                        <div className="table-modern-scroll">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead><th colSpan={2}>{t("label_indexes")}</th></thead>
                                <tbody>


                                <tr>
                                    <td><b>{t("ui_acoes_reportadas_473f06f8")}</b></td>
                                    <td>{parseInt(trust.acoes_relatadas)}</td>

                                </tr>
                                <tr>
                                    <td><b>{t("ui_media_do_reconhecimento_facial_001ef5c2")}</b></td>
                                    <td>{parseFloat(100 - trust.average_face).toFixed(2)}</td>

                                </tr>
                                <tr>
                                    <td><b>{t("ui_validacoes_faciais_periodicas_f9280df8")}</b></td>
                                    <td>{trust.face_validaiton_again}</td>

                                </tr>
                                <tr>
                                    <td><b>{t("label_photos_without_face")}</b></td>
                                    <td>{trust.no_face}</td>

                                </tr>
                                <tr>
                                    <td><b>{t("ui_numero_de_pedidos_de_liberacao_para_o_fiscal_217b2c1f")}</b></td>
                                    <td>{trust.request_validation}</td>

                                </tr>
                                <tr>
                                    <td><b>{t("legacy_saidas_de_tela")}</b></td>
                                    <td>{trust.saidas}</td>

                                </tr>
                                <tr>
                                    <td><b>{t("ui_tempo_de_saida_da_tela_de_prova_7fd35c63")}</b></td>
                                    <td>{trust.tempo}{t("unit_seconds_short")}</td>

                                </tr>
                                <tr>
                                    <td><b>{t("ui_videos_sem_rosto_57354ae0")}</b></td>
                                    <td>{parseFloat(trust.video_analyse.no_face).toFixed(2)}</td>

                                </tr>
                                <tr>
                                    <td><b>{t("ui_multiplas_rostos_de74b532")}</b></td>
                                    <td>{parseFloat(trust.video_analyse.multiple_faces_detected).toFixed(2)}</td>

                                </tr>
                                <tr>
                                    <td><b>{t("ui_ips_identicos_df44355b")}</b></td>
                                    <td>{trust.ip_equal}</td>

                                </tr>
                                <tr>
                                    <td><b>{t("trust_points_by_metric")}</b></td>
                                    <td>
                                        <div className="candidate-trust-options-grid">
                                            {getTrustMetricRows().map(item => (
                                                <label key={item.key} className={item.selected ? "candidate-trust-option" : "candidate-trust-option disabled"}>
                                                    <input
                                                        type="checkbox"
                                                        checked={item.selected}
                                                        onChange={() => toggleTrustMetric(item.key)}
                                                    />
                                                    <span>{item.label}</span>
                                                    <small>{t("label_value")}: {item.value} / {item.points.toFixed(2)} {t("video_ai_points").toLowerCase()}</small>
                                                </label>
                                            ))}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>{t("video_ai_events")}</b></td>
                                    <td>{getVideoAIEventRows().length > 0 ? getSelectedAIEventsCount() : (trust.video_ai_events || 0)}</td>

                                </tr>
                                <tr>
                                    <td><b>{t("trust_video_ai_points")}</b></td>
                                    <td>{getVideoAIEventRows().length > 0 ? getSelectedAIPoints().toFixed(2) : (trust.video_ai_points || 0)}</td>

                                </tr>
                                {getVideoAIEventRows().length > 0 && <tr>
                                    <td><b>{t("trust_ai_points_details")}</b></td>
                                    <td>
                                        <div className="candidate-trust-options-grid">
                                            {getVideoAIEventRows().map(item => (
                                                <label key={item.eventType} className={item.selected ? "candidate-trust-option" : "candidate-trust-option disabled"}>
                                                    <input
                                                        type="checkbox"
                                                        checked={item.selected}
                                                        onChange={() => toggleAIEvent(item.eventType)}
                                                    />
                                                    <span>{item.label}</span>
                                                    <small>{item.total} {t("trust_events_count")} / {item.points.toFixed(2)} {t("video_ai_points").toLowerCase()}</small>
                                                </label>
                                            ))}
                                        </div>
                                    </td>
                                </tr>}
                                <tr>
                                    <td><b>{t("title_reliability")}</b></td>
                                    <td>{getTrustMetricRows().length > 0 || getVideoAIEventRows().length > 0 ? getRecalculatedTrustPoints().toFixed(2) : parseFloat(trust_points).toFixed(2)}</td>

                                </tr>

                                </tbody>
                            </table>

                        </div>
                    </div>}




                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
              </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
          warning
          title={t("legacy_atencao")}
          onConfirm={() => {
            setShowWarning(false);
            setLoadingAllow(true);
            AccessLiberation();

            // setLoadingrelatorio(true);
            // Deleterelatorio(relatorio_id);
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            setShowWarning(false);
          }}
          show={show_warning}
          confirmBtnText={t("ui_sim_desejo_liberar_b38fec32")}
          cancelBtnText={t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>{t("ui_ao_liberar_esse_candidato_ele_tera_acesso_a_avalia_8784a55f")}


        </SweetAlert>


            </div>

        </div>);

};

export default Relatorio;
